module.exports = __webpack_public_path__ + "img/startpage-ixquick.png";